import React from "react";
import AccountManagement from "./Conversations/AccountManagement";
import EmailTemplate from "./EmailTemplate";

const FollowUpEmail = ({ setShowFollowUpEmail }) => {
  return (
    <div className="flex fixed inset-0 justify-center items-center bg-gray-800 bg-opacity-50 z-20">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        class="lucide lucide-x-icon lucide-x font-bold  absolute top-10 right-10 text-white cursor-pointer"
        onClick={() => setShowFollowUpEmail(false)}
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
      <div className="flex h-[520px] exact-xl:w-[1000px] xl:w-[1200px] bg-[var(--bg-standard)] rounded-[12px] overflow-hidden">
        <AccountManagement followUpComp={true} />
        <EmailTemplate />
      </div>
    </div>
  );
};

export default FollowUpEmail;
